import { createSlice } from '@reduxjs/toolkit'

export const slice = createSlice({
  name: 'contactslabels',
  initialState: {
    contactslabels: {},
    contactslabelsCount: 0,
    currentActiveLabelFilter: {},
  },
  reducers: {
    addNewContactLabel: (state, action) => {
      const newContactLabel = action.payload
      state.contactslabels[newContactLabel.id] = newContactLabel
    },
    removeContactLabel: (state, action) => {
      const { id } = action.payload
      if (id !== undefined) {
        const contactlabelToDelete = Object.values(state.contactslabels).find(contactlabel => contactlabel.id === id)
        delete state.contactslabels[contactlabelToDelete?.id]
        state.contactslabelsCount = state.contactslabelsCount - 1
        return state
      } else {
        throw new Error('Cannot delete contactlabel with id: undefined')
      }
    },
    editContactLabel: (state, action) => {
      const editedContactLabel = action.payload
      state.contactslabels[editedContactLabel.id] = editedContactLabel
    },
    switchCurrentActiveLabelFilter: (state, action) => {
      const currentActiveLabelFilter = action.payload
      state.currentActiveLabelFilter = currentActiveLabelFilter
    }
  }
})

export const { addNewContactLabel, removeContactLabel, editContactLabel, switchCurrentActiveLabelFilter } = slice.actions
export const selectCount = state => state.counter.value
export default slice.reducer
